var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 29.3157,
    fill: "url(#pattern0_291_338)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_291_338",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_291_338",
    transform: "matrix(0.0108577 0 0 0.0111111 0.0114045 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_291_338",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB2klEQVR4nO2cPW4CMRBGvyrkCGHDERPosjlhCBXJUSJotnKE5CIFKVx4ftbvSV+DRov8GM2KKSwBAAAAAAAAAMCNR0kHSSdJV0llpblK+pS0l7Sx/ul3kr4DSCjG+apnN+vkESWXP7JNOvsQ4LDFOa8Wok8BDlqcc7QQfQlw0OKcm4Pu/Pfla6V4nRfRQnQP6GgjEG0Eoo1AtBGINgLRRiDaCEQbgehRRY+W7ngfsAQJooVoeXchHS1/cYwO+UtlRgvR7h1X6Gi5SxpqdCyS3iRNNXP9LEt9GtHznWfPierTiN7eefZTovo0oqc7z35OVJ96dLwnqk8jeqmHa3lZRapPI7okD6KFaHl3IR0tf3GMDvlLZUZrQNHRdhHLWncd0XYRc+f67mTZRWw713cnyy5i6lzfnbXuLubG+u5k2UUs7Dq0irh19GjpjvcBS5AgWoiWdxfS0fIXl2Z0RNtFLI31aURH20XMjfVpREfbRWwb69OIjraLmBrr04iOtouYG+vTiI62i1ga69OIHi3d8T5gCRJEayWiuY5N+rEQzQWDsrlgcB9gPhbnvFiI3tSLUMugOUt6kBG7QWWf679LUzb11tnjyl+QF0kfdVyYdTIAAAAAAAAAgALzCyME6hDPk/p6AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.9b9901f6b8156a2c03d668bd97f99160.svg";
export { ForwardRef as ReactComponent };